import { useIsMedicalRecordsEnabled } from '#pplx/frontend/apps/ask/health/hooks/useIsMedicalRecordsEnabled.js';
import { useAskDeviceLocation } from '#pplx/frontend/apps/ask/locations/useAskDeviceLocation.js';
import { useCallback, useMemo } from 'react';
export const useUpsellActionHealthRuntime = ({ $t, hideUpsell, openToast, }) => {
    const { enabled: isMedicalRecordsEnabled } = useIsMedicalRecordsEnabled();
    const handleShareLocationSuccess = useCallback(() => {
        openToast({
            message: $t({
                defaultMessage: 'Location shared successfully.',
                description: 'Success toast shown when the user successfully shares their device location via an upsell action',
                id: '883420f9f4',
            }),
            variant: 'success',
            timeoutSeconds: 3,
        });
        hideUpsell?.();
    }, [openToast, $t, hideUpsell]);
    const handleShareLocationError = useCallback((error) => {
        openToast({
            message: error,
            variant: 'error',
            timeoutSeconds: 3,
        });
    }, [openToast]);
    const { requestLocation } = useAskDeviceLocation({
        origin: 'upsell_location_banner',
        onPermissionSuccess: handleShareLocationSuccess,
        onPermissionError: handleShareLocationError,
    });
    return useMemo(() => ({
        isMedicalRecordsEnabled,
        requestLocation,
    }), [isMedicalRecordsEnabled, requestLocation]);
};
//# sourceMappingURL=useUpsellActionHealthRuntime.js.map